import * as React from 'react';
import { TreeSelect } from 'antd';

import { TreeData } from '../../../../../../../../common/selects/CommonTreeSelect';
import InputControlProps from '../InputControlProps';
import { valueToList } from './treeUtils';

export interface SelectTreeProps extends InputControlProps {
  treeData: TreeData[];
}

interface SelectTreeStates {
  search: string;
  manualInputVisible: boolean;
  manualSearch: string;
}

const SHOW_PARENT = TreeSelect.SHOW_CHILD;

export class SelectTree extends React.Component<
  SelectTreeProps,
  SelectTreeStates
> {
  static defaultProps = {
    multiple: false,
    placeholder: 'Please select',
  };

  state = {
    search: '',
    manualInputVisible: true,
    manualSearch: '',
  };

  onChange = (value) => {
    this.props.onChange('[' + value.join(',') + ']');
  };

  getValueFromProps = () => {
    // Using this function to convert value to list
    const values = valueToList(this.props.value);

    return values;
  };

  render() {
    const { value, ...rest } = this.props;
    const tProps = {
      ...rest,
      onChange: this.onChange,
      value: this.getValueFromProps(),
      treeCheckable: true,
      showCheckedStrategy: SHOW_PARENT,
      searchPlaceholder: 'Please select',
      style: { width: '100%', minWidth: 200 },
    };
    return <TreeSelect {...tProps} />;
  }
}

export default SelectTree;
